import React from "react";
import "./style.scss";
import PaymentSuccess from "../../../components/Dashboard/PaymentSuccess";
const PaymentSuccessPage = () => {
  return (
    <div className="payment_success_page_wrapper">
      <PaymentSuccess />
    </div>
  );
};
export default PaymentSuccessPage;
